import { render, staticRenderFns } from "./modal-suspend.vue?vue&type=template&id=bd20a43a&scoped=true"
import script from "./modal-suspend.vue?vue&type=script&lang=js"
export * from "./modal-suspend.vue?vue&type=script&lang=js"
import style0 from "./modal-suspend.vue?vue&type=style&index=0&id=bd20a43a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd20a43a",
  null
  
)

export default component.exports